import Vue from 'vue'
import router from './router'
import store from './store'
import App from './App.vue'
import Axios from 'axios'
import preview from 'vue-photo-preview'
import 'vue-photo-preview/dist/skin.css'
import './css/error-tip.scss'
import './css/loading.scss'
import './css/picker.scss'
import './css/common.css'
import loading from './common/loading'
import {Tab, Tabs, Lazyload, Swipe, SwipeItem, Popup, DatetimePicker} from 'vant';

Vue.use(Tab).use(Tabs).use(loading).use(Swipe).use(SwipeItem).use(Popup).use(DatetimePicker).use(Lazyload, {
    lazyComponent: true,
});
Vue.config.productionTip = false;
Vue.prototype.$http = Axios;

Vue.use(preview);
new Vue({
    router,
    store,
    render: h => h(App),
}).$mount('#app');
